export default "__VITE_ASSET__BN4fK7kN__"